module.exports = __webpack_public_path__ + "static/media/empire-logo.f3df8bbd.png";